import { TimetableVersionTeachersMatrix } from '../../../../../../components/TimetableVersion/TimetableVersionDataAvailabilityMatrix/TimetableVersionTeachersMatrix';
import { TimetableVersionTeacherConditions } from '../../../../../../components/TimetableVersion/TimetableVersionDataConditions/TimetableVersionTeacherConditions';
import { TimetableVersionTeachersTable } from '../../../../../../components/TimetableVersion/TimetableVersionDataTables/TimetableVersionTeachersTable';
import { hexToColorOption } from '../../../../../../utils/colorUtils';
import { TimetableResourceDataPage, timetableResourceConfig } from '../TimetableResourceDataPage';

const teacherConfig = timetableResourceConfig({
  availabilityResourceType: 'teacher',
  relationKey: 'teachers',
  lessonFilterColumn: 'teachers',
  importLabelKey: 'persons.title',
  selectVersionUuids: (store) => Array.from(store.teachers.keys()),
  selectEntities: (basicData) => basicData.teacherData?.people,
  mapRow: (t) => {
    const { html, label } = hexToColorOption(t.timetableConfig?.color ?? '');
    return {
      uuid: t.uuid,
      name: t.displayNameShort ?? t.fullName,
      count: 0,
      shortName: t.shortName,
      color: { color: html, colorLabel: label },
    };
  },
  addEntities: (store, entities) => store.addTeachers([...entities]),
  removeEntities: (store, uuids) => store.removeTeachers(uuids),
  renderMatrix: ({ selected, loading, versionUuid, timeGridEntries, onChange }) => (
    <TimetableVersionTeachersMatrix
      timeGridEntries={timeGridEntries}
      versionUuid={versionUuid}
      selected={selected}
      loading={loading}
      onChange={onChange}
    />
  ),
  renderTable: ({ versionUuid, versionUuids, search, onRowSelection, onRemove, onShowLessonClick }) => (
    <TimetableVersionTeachersTable
      onRowSelection={onRowSelection}
      onRemove={onRemove}
      versionTeacherUuids={versionUuids}
      versionUuid={versionUuid}
      search={search}
      onShowLessonClick={onShowLessonClick}
    />
  ),
  renderConditions: ({ versionUuid, selected, ...control }) =>
    versionUuid && selected ? (
      <TimetableVersionTeacherConditions
        key={selected.uuid}
        versionUuid={versionUuid}
        teacherUuid={selected.uuid}
        name={selected.name}
        {...control}
      />
    ) : null,
});

export const PlanTimetableTeachers = () => <TimetableResourceDataPage config={teacherConfig} />;
